// App.js
import React, { createContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

import Home from './pages/Home';
import Container from './layout/Container';
import Download from './pages/Download';
import Produto from './pages/Produto';
import Produtos from './pages/Produtos';
import CadastroScreen from './pages/CadastroScreen';
import CategoriasProdutos from './pages/CategoriasProdutos';
import TelaLogin from './pages/TelaLogin';

import PedidoStatusLayout from './pages/componentes-frete/PedidoStatusLayout';
import FormularioLayout from './pages/Formulario/formularioLayout';

import { UserProvider } from './pages/context/UserProvider';

// Context para expor o interceptor globalmente
export const BackInterceptorContext = createContext({
  interceptBack: false,
  setInterceptBack: (_v) => { },
});

function AppRoutesWrapper() {
  // wrapper apenas para poder usar useLocation (se necessário)
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/download" element={<Download />} />
      <Route path="/telaLogin" element={<TelaLogin />} />
      <Route path="/produtos/:categoria_id" element={<Produtos />} />
      <Route path="/produtos" element={<Produtos />} />

      <Route path="/produto/:id" element={<Produto />} />
      <Route path="/categoria" element={<CategoriasProdutos />} />
      <Route path="/CadastroScreen" element={<CadastroScreen />} />
      <Route path="/pedidostatuslayout" element={<PedidoStatusLayout />} />
      <Route path="/formulariolayout" element={<FormularioLayout />} />
    </Routes>
  );
}

function App() {
  const [interceptBack, setInterceptBack] = useState(false);

  useEffect(() => {
    // Quando interceptBack vira true, criamos uma entrada no history
    if (interceptBack) {
      // pushState para que o botão voltar dispare popstate
      window.history.pushState({ intercepted: true }, "");
    }
  }, [interceptBack]);

  useEffect(() => {
    const onPopState = (event) => {
      // Se estivermos interceptando, consumimos o "voltar":
      if (interceptBack) {
        // aqui mudamos o estado para false — componentes que dependem
        // desse estado devem reagir (ex.: fechar modal/painel)
        setInterceptBack(false);

        // opcional: limpamos o history state atual para evitar loops
        window.history.replaceState(null, "");
      } else {
        // Não estamos interceptando: deixamos o comportamento normal acontecer.
        // (react-router vai tratar a navegação)
      }
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [interceptBack]);

  return (
    <UserProvider>
      <BackInterceptorContext.Provider value={{ interceptBack, setInterceptBack }}>
        <Router>
          {/* Se quiser usar Container como layout comum, coloque aqui */}
          <Container customClass='min-height'>
            <AppRoutesWrapper />
          </Container>
        </Router>
      </BackInterceptorContext.Provider>
    </UserProvider>
  );
}

export default App;
